<div class="bg-light min-vh-100 d-flex flex-row align-items-center">
  <c-container>
    <c-row class="justify-content-center">
      <c-col lg="6" md="9" xl="6">
        <c-card class="mx-4">
          <c-card-body class="p-4">
            <form cForm [formGroup]="form" (submit)="onSubmit()">
              <div class="row">
                <div class="col-7">
                  <h1>Senha</h1>
                  <p class="text-medium-emphasis">Recupere sua senha!</p>
                </div>
                <div class="col-5" style="text-align-last: end;">
                  <img src="assets/img/brand/logo-ladder.png" style="height: 70px" alt="Logo" />
                </div>
              </div>

              <c-input-group class="mb-3">
                <span cInputGroupText>
                  <svg cIcon name="cilUser"></svg>
                </span>
                <input autoComplete="username" cFormControl placeholder="Usuário" formControlName="username" required />
              </c-input-group>

              <c-row>
                <c-col xs="6">
                  <button cButton class="px-4" color="primary" type="submit" [disabled]="form.invalid">
                    Recuperar Senha
                  </button>
                </c-col>
                <c-col class="text-right" xs="6" style="text-align-last: end;">
                  <button cButton class="px-0" color="link" (click)="goToLogin()">
                    Voltar ao Login
                  </button>
                </c-col>
              </c-row>
            </form>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
  </c-container>
</div>
